export default __webpack_public_path__ + "static/media/financing.10055b1f.jpg";